import React from 'react';
import { Modal, FormInput, Button } from '@/components/ui';

export const AssignEmployeesModal = ({
  isOpen,
  onClose,
  handleAssign,
  employeeSearchQuery,
  setEmployeeSearchQuery,
  employees,
  selectedAssignees,
  handleToggleAssignee,
  isAssigning
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Assign Employees"
      size="md"
    >
      <form onSubmit={handleAssign} className="flex flex-col gap-4">
        <FormInput
          type="text"
          placeholder="Search employees..."
          value={employeeSearchQuery}
          onChange={(e) => setEmployeeSearchQuery(e.target.value)}
        />
        <div className="h-96 overflow-y-auto border border-gray-200 rounded-xl p-2 bg-gray-50 shadow-inner">
          {employees.length === 0 ? (
            <p className="text-sm text-gray-500 text-center py-8">No active employees found.</p>
          ) : (
            employees
              .filter(emp => {
                const fullName = `${emp.firstName} ${emp.lastName}`.toLowerCase();
                return fullName.includes(employeeSearchQuery.toLowerCase()) ||
                  (emp.role || '').toLowerCase().includes(employeeSearchQuery.toLowerCase());
              })
              .map(emp => (
                <label key={emp._id} className="flex items-center gap-3 p-3 mb-1 hover:bg-white bg-transparent rounded-lg cursor-pointer transition-colors border border-transparent hover:border-gray-200 hover:shadow-sm">
                  <input
                    type="checkbox"
                    className="w-5 h-5 text-purple-600 rounded border-gray-300 focus:ring-purple-500 transition-all cursor-pointer"
                    checked={selectedAssignees.includes(emp._id)}
                    onChange={() => handleToggleAssignee(emp._id)}
                  />
                  <div>
                    <p className="text-sm font-semibold text-gray-800">{emp.firstName} {emp.lastName}</p>
                    <p className="text-xs text-gray-500 capitalize">{emp.role?.replace('_', ' ')}</p>
                  </div>
                </label>
              ))
          )}
        </div>
        <div className="flex gap-3 mt-4">
          <Button variant="outline" className="flex-1" onClick={onClose} type="button">
            Cancel
          </Button>
          <Button type="submit" variant="purple" className="flex-1" loading={isAssigning} disabled={isAssigning}>
            Save Assignment
          </Button>
        </div>
      </form>
    </Modal>
  );
};
